import React, { FC, useEffect, useState } from 'react';
import { SCUIButton, SCUINoRecordComponent, SCUILoadingLinear, SCUIDateRanger } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { SCUIBreadCrumb, SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { Grid, FormControl, MenuItem, Select, InputLabel, Box } from '@mui/material';
import { initialState } from './CargoFeeManagement.helper';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { CargoFeeManagementQuery } from '../../services/query/';
import { SCUICargoFeeEdit } from './components/SCUICargoFeeEdit/SCUICargoFeeEdit';
import { SCUICargoFeeAdd } from './components/SCUICargoFeeAdd/SCUICargoFeeAdd';
import { SCUICargoFeeUploadComponent } from './components/SCUICargoFeeUploadComponent/SCUICargoFeeUploadComponent';
import { CargoFeeManagementCommand } from '../../services/command';
import TimeHelper from '../../utils/time';
import { downloadExcel } from '../../utils/excelFileHelper';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { CFM, cfmCls } from './cargoFeeManagement.classes';

export const CargoFeeManagement: FC<any> = () => {
    const filterInfo = initialState.filterInfo;
    const filterInput = initialState.filterInfo;

    const { t } = useTranslation();
    const [companyList, setCompanyList] = useState([]);
    const [distanceTypeList, setDistanceTypeList] = useState([]);
    const [departureLocationList, setDepartureLocationList] = useState([]);
    const [filterRespData, setFilterRespData] = React.useState<any>();
    const [companyId, setCompanyId] = React.useState(-1);
    const [distanceTypeId, setDistanceTypeId] = React.useState(-1);
    const [departureLocationTypeId, setDepartureLocationTypeId] = React.useState(-1);
    const [loading, setLoading] = React.useState(false);
    const [drawerEditOpen, setDrawerEditOpen] = React.useState(false);
    const [drawerAddOpen, setDrawerAddOpen] = React.useState(false);
    const [selectedOrderItem, setSelectedOrderItem] = useState<any>();
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [endDate, setEndDate] = useState('');
    const [createdDate, setCreatedDate] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [orderNo, setOrderNo] = useState('');
    useEffect(() => {
        setSelectedOrderItem(selectedRows);
    }, [selectedRows]);
    useEffect(() => {
        GetCargoCompanyList();
        GetDistanceTypeList();
        DepartureLocationTypeList();
    }, []);
    const _handlChangeDate = (event: any) => {
        setCreatedDate(event[0]);
        setEndDate(event[1]);
    };
    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    const handleModalOpen = () => {
        setIsModalOpen(true);
    };

    const GetCargoCompanyList = async () => {
        try {
            CargoFeeManagementQuery.CargoCompanyList().then((res: any) => {
                if (res.data) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            value: item.id,
                            text: item.name,
                        };
                    });
                    setCompanyList(parseData && [...[{ value: '-1', text: t('general.all') }], ...parseData]);
                } else {
                    Swal.fire('Service Error', res.errorMessage, 'error');
                }
            });
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetDistanceTypeList = async () => {
        try {
            CargoFeeManagementQuery.GetDistanceTypeList().then((res: any) => {
                if (res.data) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            value: item.id,
                            text: item.name,
                        };
                    });
                    setDistanceTypeList(parseData && [...[{ value: '-1', text: t('general.all') }], ...parseData]);
                } else {
                    Swal.fire('Service Error', res.errorMessage, 'error');
                }
            });
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const DepartureLocationTypeList = async () => {
        try {
            CargoFeeManagementQuery.DepartureLocationTypeList().then((res: any) => {
                if (res.data) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            value: item.id,
                            text: item.name,
                        };
                    });
                    setDepartureLocationList(parseData && [...[{ value: '-1', text: t('general.all') }], ...parseData]);
                } else {
                    Swal.fire('Service Error', res.errorMessage, 'error');
                }
            });
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const columns: ExtendedGridColDef[] = [
        {
            field: 'shippingCompanyId',
            headerName: 'shippingCompanyId',
            flex: 1,
            hide: true,
        },
        {
            field: 'shippingCompanyPriceId',
            headerName: t('cargoFeeManagement.shippingCompanyPriceId'),
            flex: 1,
            hide: true,
        },
        {
            field: 'shippingCompanyName',
            headerName: t('cargoFeeManagement.shippingCompanyName'),
            flex: 1,
        },
        {
            field: 'distanceTypeName',
            headerName: t('cargoFeeManagement.distanceTypeName'),
            flex: 1,
        },
        {
            field: 'departureLocationTypeName',
            headerName: t('cargoFeeManagement.departureLocationTypeName'),
            flex: 1,
        },
        {
            field: 'desi',
            headerName: t('cargoFeeManagement.desi'),
            flex: 1,
        },
        {
            field: 'price',
            headerName: t('cargoFeeManagement.price'),
            flex: 1,
        },
        {
            field: 'validStartDateForGrid',
            headerName: t('cargoFeeManagement.validStartDate'),
            flex: 1,
        },
        {
            field: 'validEndDateForGrid',
            headerName: t('cargoFeeManagement.validEndDate'),
            flex: 1,
        },
    ];
    const handleChangeFilterInput = () => {
        listele();
    };
    const onDrawerEditClose = () => setDrawerEditOpen(false);
    const onDrawerAddClose = () => setDrawerAddOpen(false);

    const handleDrawerAdd = (value: boolean) => {
        setDrawerAddOpen(value);
        setSelectedRows([]);
    };

    const handleSelectionModelChange = (model: any[]) => {
        const selectedData = model.map((id: number) => {
            return filterRespData.find((city: any) => city.id === id);
        });
        setSelectedRows(selectedData);
    };
    const listele = async () => {
        setLoading(true);

        try {
            let params = {
                shippingCompanyId: companyId,
                distanceTypeId: distanceTypeId,
                departureLocationTypeId: departureLocationTypeId,
                validStartDate: createdDate,
                validEndDate: endDate,
            };
            CargoFeeManagementQuery.GetFilteredShippingCompanyPrices(params).then((res: any) => {
                if (res) {
                    let parseData = res.data.map((item: any, index: any) => {
                        return {
                            id: index,
                            shippingCompanyPriceId: item.shippingCompanyPriceId,
                            shippingCompanyId: item.shippingCompanyId,
                            shippingCompanyName: item.shippingCompanyName,
                            distanceTypeId: item.distanceTypeId,
                            distanceTypeName: item.distanceTypeName,
                            departureLocationTypeId: item.departureLocationTypeId,
                            departureLocationTypeName: item.departureLocationTypeName,
                            desi: item.desi,
                            price: item.price,
                            validStartDateForGrid: TimeHelper.formatDate(item.validStartDate) ?? '',
                            validStartDate: item.validStartDate,
                            validEndDateForGrid: TimeHelper.formatDate(item.validEndDate) ?? '',
                            validEndDate: item.validEndDate,
                            isActive: item.isActive,
                        };
                    });
                    setFilterRespData(parseData);
                } else {
                    Swal.fire('Service Error', res.errorMessage, 'error');
                }
            });
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
        setLoading(false);
    };
    const refreshFunc = () => {
        listele();
    };

    const downloadExcelHandler = () => {
        downloadExcel({
            excelDownloadData: filterRespData,
            hiddenExcelColumn: [
                'id',
                'shippingCompanyPriceId',
                'shippingCompanyId',
                'distanceTypeId',
                'departureLocationTypeId',
                'isActive',
                'validStartDate',
                'validEndDate',
            ],
            excelDownloadFolderName: 'Kargo Fiyat Yönetimi',
        });
    };

    return (
        <SCUIContent className={`${CFM.page} `}>
            <SCUIGeneralDrawer
                open={drawerEditOpen}
                width={'360px'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerEditOpen(false);
                    }
                }}
            >
                <SCUICargoFeeEdit
                    selectedRow={selectedOrderItem}
                    onClose={onDrawerEditClose}
                    refresh={refreshFunc}
                    setSelectedRow={setSelectedRows}
                />
            </SCUIGeneralDrawer>
            <SCUIGeneralDrawer
                open={drawerAddOpen}
                width={'360px'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerAddOpen(false);
                    }
                }}
            >
                <SCUICargoFeeAdd
                    onClose={onDrawerAddClose}
                    refresh={refreshFunc}
                    filterInput={filterInput}
                    companyList={companyList}
                    distanceTypeList={distanceTypeList}
                    departureLocationList={departureLocationList}
                />
            </SCUIGeneralDrawer>
            <Grid
                className={CFM.layout}
                size={{
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <Grid
                    className={CFM.breadcrumbRow}
                    container
                    direction="row"
                    spacing={2}
                    sx={{ marginLeft: '0.5rem' }}
                >
                    <SCUIBreadCrumb
                        title={'Kargo Ücret Yönetimi'}
                        componentLink={'/CargoFeeManagement'}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setFilterRespData([]);
                            setSelectedRows([]);
                        }}
                    />
                    <SCUILoadingLinear display={loading} />
                </Grid>

                <Grid
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    {filterRespData && filterRespData.length > 0 && (
                        <Grid
                            className={CFM.toolbarActions}
                            style={{ direction: 'rtl', display: 'flex', gap: '1rem' }}
                            size={{
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <SCUIButton
                                text={''}
                                type="secondary"
                                sizeType="fixed"
                                size={'m'}
                                className={cfmCls(CFM.input, CFM.inputButton, CFM.btnBulkDelete)}
                                onClick={() => {
                                    if (selectedRows.length > 0) {
                                        Swal.fire({
                                            text: 'Silmek istediğinize emin misiniz?',
                                            cancelButtonText: t('general.cancel'),
                                            icon: 'warning',
                                            showCancelButton: true,
                                            confirmButtonText: t('general.complete'),
                                        }).then((result: any) => {
                                            if (result.isConfirmed) {
                                                let datas = selectedRows.map((row: any) => {
                                                    return {
                                                        id: row.shippingCompanyPriceId,
                                                    };
                                                });
                                                CargoFeeManagementCommand.DeleteCargoFee(datas).then(() => {
                                                    Swal.fire(t('general.recordDeleted'), ' ', 'success');
                                                    setSelectedRows([]);
                                                    refreshFunc();
                                                });
                                            }
                                        });
                                    } else {
                                        Swal.fire('Error', t('general.noSelectionMade'), 'error');
                                    }
                                }}
                            >
                                {' '}
                                <DeleteIcon />
                            </SCUIButton>
                            <SCUIButton
                                text={'Düzenle'}
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                className={cfmCls(CFM.input, CFM.inputButton, CFM.btnEdit)}
                                onClick={() => {
                                    if (selectedRows.length > 0) {
                                        setDrawerEditOpen(true);
                                    } else {
                                        Swal.fire('Error', t('general.noSelectionMade'), 'error');
                                    }
                                }}
                            />
                            <SCUIButton
                                text={'Yeni Ekle'}
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                className={cfmCls(CFM.input, CFM.inputButton, CFM.btnAddNew)}
                                onClick={() => {
                                    handleDrawerAdd(true);
                                }}
                            />

                            <Grid>
                                <SCUIButton
                                    text={'Excel Yükle'}
                                    type="secondary"
                                    sizeType="fixed"
                                    size={'m'}
                                    className={cfmCls(CFM.input, CFM.inputButton, CFM.btnExcelUpload)}
                                    onClick={handleModalOpen}
                                />
                                <SCUICargoFeeUploadComponent
                                    open={isModalOpen}
                                    handleModalClose={handleModalClose}
                                    onClose={handleModalClose}
                                    orderNo={orderNo}
                                    setOrderNo={setOrderNo}
                                    loadingExcel={loadingExcel}
                                    setLoadingExcel={setLoadingExcel}
                                />
                            </Grid>
                        </Grid>
                    )}
                    <Grid
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        {filterRespData && filterRespData.length > 0 ? (
                            <div>
                                <Grid
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <SCUIButton
                                        type={'primary'}
                                        sizeType={'fixed'}
                                        style={{ marginBottom: '12px' }}
                                        size={'s'}
                                        text={t('general.exportToExcel')}
                                        showStartIcon
                                        startIcon={<FileDownloadIcon style={{ color: 'white' }} />}
                                        onClick={downloadExcelHandler}
                                        className={cfmCls(CFM.input, CFM.inputButton, CFM.btnExportExcel)}
                                    />
                                    <Box className={CFM.datagrid}>
                                        <SCUICustomDataGrid
                                            selectionOnClick={true}
                                            checkboxSelection
                                            rows={filterRespData}
                                            columns={columns}
                                            onSelectionModelChange={handleSelectionModelChange}
                                            selectionModel={selectedRows.map((row) => row.id)}
                                            slotProps={{
                                                baseCheckbox: {
                                                    className: cfmCls(CFM.input, CFM.inputCheckbox, CFM.cbGridSelection),
                                                },
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            </div>
                        ) : (
                            <div
                                className={CFM.filterPanel}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignContent: 'center',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <SCUINoRecordComponent />

                                <FormControl
                                    className={CFM.fieldFilterCompany}
                                    style={{ width: 450, margin: '20px' }}
                                >
                                    <InputLabel id="labelApp">{t('cargoFeeManagement.selectCargoCompany')}</InputLabel>
                                    <Select
                                        className={cfmCls(CFM.input, CFM.inputSelect, CFM.fieldFilterCompany)}
                                        label={t('cargoFeeManagement.selectCargoCompany')}
                                        labelId="labelApp"
                                        id="parentMenuLabel"
                                        value={companyId}
                                        onChange={(event) => {
                                            setCompanyId(Number(event.target.value));
                                        }}
                                        fullWidth
                                    >
                                        {companyList &&
                                            companyList.map((comp: any) => (
                                                <MenuItem key={comp.value} id={comp.value} value={comp.value}>
                                                    {comp.text}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>

                                <FormControl
                                    className={CFM.fieldFilterDistance}
                                    style={{ width: 450, margin: '20px' }}
                                >
                                    <InputLabel id="labelApp">{t('cargoFeeManagement.selectDistanceType')}</InputLabel>
                                    <Select
                                        className={cfmCls(CFM.input, CFM.inputSelect, CFM.fieldFilterDistance)}
                                        label={t('cargoFeeManagement.selectDistanceType')}
                                        labelId="labelApp"
                                        id="parentMenuLabel"
                                        value={distanceTypeId}
                                        onChange={(event) => {
                                            setDistanceTypeId(Number(event.target.value));
                                        }}
                                        fullWidth
                                    >
                                        {distanceTypeList &&
                                            distanceTypeList.map((dist: any) => (
                                                <MenuItem key={dist.value} id={dist.value} value={dist.value}>
                                                    {dist.text}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                                <FormControl
                                    className={CFM.fieldFilterDeparture}
                                    style={{ width: 450, margin: '20px' }}
                                >
                                    <InputLabel id="labelApp">
                                        {t('cargoFeeManagement.selectdeparturelocationtype')}
                                    </InputLabel>
                                    <Select
                                        className={cfmCls(CFM.input, CFM.inputSelect, CFM.fieldFilterDeparture)}
                                        label={t('cargoFeeManagement.selectdeparturelocationtype')}
                                        labelId="labelApp"
                                        id="parentMenuLabel"
                                        value={departureLocationTypeId}
                                        onChange={(event) => {
                                            setDepartureLocationTypeId(Number(event.target.value));
                                        }}
                                        fullWidth
                                    >
                                        {departureLocationList &&
                                            departureLocationList.map((dist: any) => (
                                                <MenuItem key={dist.value} id={dist.value} value={dist.value}>
                                                    {dist.text}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                                <Grid
                                    className={CFM.filterDateRange}
                                    sx={{ marginBottom: 2, width: 450 }}
                                    size={{
                                        xs: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <SCUIDateRanger
                                        fromDate={filterInfo.createDate}
                                        toDate={filterInfo.endDate}
                                        setDateRange={_handlChangeDate}
                                        dateFormat="YYYY-MM-DD"
                                        fullWidth
                                    />
                                </Grid>
                                <FormControl style={{ width: 450, margin: '10px' }}>
                                    <SCUIButton
                                        text={t('general.filter')}
                                        type="primary"
                                        sizeType="default"
                                        size={'l'}
                                        className={cfmCls(CFM.input, CFM.inputButton, CFM.btnFilter)}
                                        onClick={() => {
                                            handleChangeFilterInput();
                                        }}
                                    />
                                </FormControl>
                            </div>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
